<template>
  <span class="motion-state" v-if="showShow" :class="classname">{{text}}</span>
</template>

<script>
import MotionState from '../../enums/motion-state'
export default {
  name: 'MotionStateDisplay',
  props: {
    state: {
      type: String,
      required: true
    },
    reason: {
      type: String,
      required: false
    },
    hideIfPending: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showShow () {
      if (!this.hideIfPending) {
        return true
      }
      return this.state !== MotionState.PENDING
    },
    classname () {
      if (this.state === MotionState.HOLD) {
        return 'motion-state-hold'
      }
      if (this.state === MotionState.ACTIVE) {
        return 'motion-state-active'
      }
      if (this.state === MotionState.PENDING) {
        return 'motion-state-pending'
      }
      if (this.state === MotionState.PASSED) {
        return 'motion-state-passed'
      }
      if (this.state === MotionState.FAILED) {
        return 'motion-state-failed'
      }
      return this.state
    },
    text () {
      if (this.state === MotionState.HOLD) {
        return 'On Hold'
      }
      if (this.state === MotionState.ACTIVE) {
        return 'Active'
      }
      if (this.state === MotionState.PENDING) {
        return 'Pending'
      }
      if (this.state === MotionState.PASSED) {
        if (this.reason === 'withdrawn') {
          return 'Withdrawn'
        }
        if (this.reason === 'division_carried') {
          return 'Division Carried'
        }
        if (this.reason === 'main') {
          return 'Moved to Main Question'
        }
        return 'Carried'
      }
      if (this.state === MotionState.FAILED) {
        if (this.reason === 'passed') {
          return 'Carried'
        }
        if (this.reason === 'lost') {
          return 'Lost'
        }
        if (this.reason === 'division_lost') {
          return 'Division Lost'
        }
        return this.reason
      }
      return this.state
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/motions/MotionStateDisplay.vue